import {
  formatInstrumentRate,
  getInstrumentMeta,
  type MarketInstrumentKey,
} from '@/lib/market-rates'

type MarketRateValueProps = {
  instrumentKey: MarketInstrumentKey
  rate?: number | null
  decimals?: number
  busy?: boolean
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const TEXT_SIZE = {
  sm: 'text-xs font-black sm:text-sm',
  md: 'text-sm font-black sm:text-base',
  lg: 'text-3xl font-black sm:text-4xl',
} as const

export default function MarketRateValue({
  instrumentKey,
  rate,
  decimals,
  busy = false,
  size = 'sm',
  className = '',
}: MarketRateValueProps) {
  const meta = getInstrumentMeta(instrumentKey)
  const amount =
    busy || rate == null || !Number.isFinite(rate) || rate === 0
      ? '----'
      : formatInstrumentRate(instrumentKey, rate, decimals ?? meta.decimals)

  return (
    <span className={`tabular-nums text-gray-900 dark:text-gray-100 ${TEXT_SIZE[size]} ${className}`}>
      {amount}
    </span>
  )
}
